var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "otpForm" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.validateBeforeSubmit($event)
        },
      },
    },
    [
      _c(
        "div",
        { class: { "form-group": true } },
        [
          _c("p", { staticClass: "input-label" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("login.enter_otp")) + " "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          ]),
          _vm._v(" "),
          _c("base-input", {
            attrs: {
              invalid: _vm.$v.otpData.code.$error,
              placeholder: "",
              focus: "",
              type: "number",
              name: "code",
            },
            on: {
              input: function ($event) {
                return _vm.$v.otpData.code.$touch()
              },
            },
            model: {
              value: _vm.otpData.code,
              callback: function ($$v) {
                _vm.$set(_vm.otpData, "code", $$v)
              },
              expression: "otpData.code",
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.otpData.id,
                expression: "otpData.id",
              },
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.otpData.id },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.otpData, "id", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.$v.otpData.code.$error
            ? _c("div", [
                !_vm.$v.otpData.code.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc("validation.required")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.otpData.code.minLength
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc("validation.digits_otp")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.otpData.code.maxLength
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc("validation.digits_otp")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "base-button",
            {
              attrs: {
                loading: _vm.isLoading,
                type: "submit",
                color: "success",
              },
            },
            [_vm._v(_vm._s(_vm.$t("login.submit_otp")))]
          ),
          _vm._v(" "),
          _c(
            "base-button",
            {
              staticStyle: { marginLeft: "10px" },
              attrs: {
                loading: _vm.resendLoading,
                type: "button",
                color: "theme",
              },
              on: { click: _vm.resend },
            },
            [_vm._v(_vm._s(_vm.$t("login.resend_otp")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "other-actions row" }, [
        _c("div", { staticClass: "col-sm-12 text-sm-left mb-4" }, [
          _c("p", { staticClass: "support-line" }, [
            _vm._v(_vm._s(_vm.$t("login.expiration_otp"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "support-line" }, [
            _vm._v(_vm._s(_vm.$t("login.support_line"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }